export const EXPERIMENT_PAGE_TEST = 'pageTest' as const;
export const EXPERIMENT_PAGE_TEST_ORIGINAL = 'original' as const;
export const EXPERIMENT_PAGE_TEST_VARIATION = 'variation' as const;

export const EXPERIMENT_HOMEPAGE_SHOWROOM_CTA = 'homepageShowroomCtaTest' as const;
export const EXPERIMENT_HOMEPAGE_SHOWROOM_CTA_ORIGINAL = 'showroomCalloutInvisible' as const;
export const EXPERIMENT_HOMEPAGE_SHOWROOM_CTA_PARAGRAPH = 'showroomCalloutParagraph' as const;
export const EXPERIMENT_HOMEPAGE_SHOWROOM_CTA_BULLETED = 'showroomCalloutBulleted' as const;
